import { DataTable } from "@/components/molecules/tables/data-table";
import { Button } from "@/components/ui/button";
import { AdminAPI, useDemoSpaces } from "@/features/admin";
import { FileJson, FileSpreadsheet } from "lucide-react";
import { AdminPageLayout } from "../layout";
import { columns } from "./components/columns";
import { ImportCard, saveFile } from "./components/import-card";

/**
 * Pre-built demo spaces (HEY-34): a CSV of businesses becomes a tenant each, set up
 * from its own website as if its owner had gone through the onboarding on the
 * demo number, plus a six-digit code the routing agent accepts. The exports are
 * what the mailing is made from (CSV) and what the quality of the reading is
 * judged on (JSON).
 */
export function AdminDemoSpacesPage() {
  const { data, isLoading } = useDemoSpaces();
  const spaces = data?.spaces ?? [];
  const numbers = data?.demo_numbers ?? [];

  return (
    <AdminPageLayout
      title="Espaces de démo"
      description={
        numbers.length
          ? `Numéro à appeler : ${numbers.join(" · ")}`
          : "Aucun numéro maître n'est configuré pour le routage par code"
      }
      actions={
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            onClick={() =>
              saveFile(() => AdminAPI.getDemoSpacesCsv(), "espaces-demo.csv")
            }
          >
            <FileSpreadsheet className="h-4 w-4" />
            Export courrier (CSV)
          </Button>
          <Button
            variant="outline"
            onClick={() =>
              saveFile(() => AdminAPI.getDemoSpacesJson(), "espaces-demo.json")
            }
          >
            <FileJson className="h-4 w-4" />
            Export complet (JSON)
          </Button>
        </div>
      }
    >
      <ImportCard />
      <DataTable
        columns={columns}
        data={spaces}
        isLoading={isLoading}
        density="compact"
      />
    </AdminPageLayout>
  );
}
